<template>
    <div class="form-group" :class="{ 'has-error' : controller.hasError,'has-warning' : controller.hasWarning ,'has-success' : controller.hasSuccess}">
        <label class="control-label">{{controller.name}}</label> 
        <a  href="#" @click.prevent.stop="flip()">
            <span class="fa-stack fa-lg">
                <i class="fa fa-square-o fa-stack-2x"></i>
                <i v-if="controller.value" class="fa fa-check fa-stack-1x"></i>
            </span>
        </a>
        <span class="help-block" v-if="controller.hasWarning || controller.hasError">
            <i class="fa" v-bind:class="{ 'fa-exclamation-circle' : controller.hasError,'fa-exclamation-triangle' : controller.hasWarning }"></i>
            <small>{{controller.message}}</small>
        </span>
    </div>
</template>
<script>

    export default {
        props: ['controller'],
        data: function () {
            return {

            }
        },
        methods: {
            flip() {
                this.controller.value = !this.controller.value;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// formcheckbox.scp.html?d7853c38